import { analytics } from 'utils/analytics';

export interface SponsoredProductGAEventData {
  contentId: string;
  searchQuery: string;
  productName: string;
  productId: number;
  productPrice: number | null;
  productPosition: number;
  productPrevPrice: number | null;
  productDiscount: number | null;
  productTag: string | null;
  productBelong: string;
}

const sponsoredProductImpressioned: string[] = [];
const sponsoredProductClicked: string[] = [];

export const sendSponsoredProductImpression = ({
  contentId,
  searchQuery,
  productName,
  productId,
  productPrice,
  productPosition,
  productPrevPrice,
  productTag,
  productBelong,
  productDiscount,
}: SponsoredProductGAEventData) => {
  if (!!contentId && !sponsoredProductImpressioned.includes(contentId)) {
    analytics.sendEvent('GA:impressions', {
      elementType: 'product',
      elementBlock: 'headerSearch',
      elementName: 'searchProduct',
      eventVariant: searchQuery,
      productName,
      productId,
      productPrice,
      productPosition,
      productPrevPrice,
      productTag,
      isMonetization: true,
      productBelong,
      productDiscount,
    });

    sponsoredProductImpressioned.push(contentId);
  }
};

export const sendSponsoredProductClick = ({
  contentId,
  searchQuery,
  productName,
  productId,
  productPrice,
  productPosition,
  productPrevPrice,
  productTag,
  productBelong,
  productDiscount,
}: SponsoredProductGAEventData) => {
  if (!!contentId && !sponsoredProductClicked.includes(contentId)) {
    analytics.sendEvent('GA:clickProduct', {
      elementType: 'product',
      elementBlock: 'headerSearch',
      elementName: 'searchProduct',
      eventVariant: searchQuery,
      productName,
      productId,
      productPrice,
      productPosition,
      productPrevPrice,
      productTag,
      isMonetization: true,
      productBelong,
      productDiscount,
    });

    sponsoredProductClicked.push(contentId);
  }
};
